import { GAME_CONFIG } from '../economy/config';
export type * from './types';
export { formatStripeMoney, parseStripeMoney, stripeCurrencyDigits } from './money';
export { DEFAULT_SITE_PALETTES, SITE_PALETTE_COLORS, colorContrast, paletteContrastValid,
  parseSitePalettes, sitePaletteSchema, sitePalettesSchema, sitePaletteTokens } from './site-palette';
export type { SitePalette, SitePaletteColor, SitePalettes } from './site-palette';

export const PREMIUM_PLAN = {
  key: 'anidex-premium-monthly-v1',
  name: 'ANIDEX Premium',
  amount: 399,
  currency: 'eur',
  interval: 'month',
  termsVersion: '2026-10-11',
  maxBoosterBatch: 50,
  maxFriends: 500,
  maxPendingRequests: 100,
  showcaseSlots: 12,
  maxCustomCardImages: 20,
  maxTradeCardsPerSide: 30,
  maxTradeAnima: 50_000,
  maxImageBytes: 15 * 1024 * 1024,
  maxImageDimension: 4096,
} as const;

export const PREMIUM_COSMETICS = {
  title: 'premium_supporter',
  frame: 'premium_orbit',
  avatar: 'premium_stardust',
  banner: 'premium_constellation',
} as const;

export interface PremiumAccess {
  premium_until?: string | null;
  status?: string;
}

export function hasPremium(user: PremiumAccess | null | undefined, nowMs = Date.now()): boolean {
  if (!user?.premium_until || (user.status !== undefined && user.status !== 'active')) return false;
  const until = Date.parse(user.premium_until);
  return Number.isFinite(until) && until > nowMs;
}

export function premiumLimits(active: boolean) {
  return {
    maxBoosterBatch: active ? PREMIUM_PLAN.maxBoosterBatch : Math.max(...GAME_CONFIG.allowedQuantities),
    maxFriends: active ? PREMIUM_PLAN.maxFriends : GAME_CONFIG.social.maxFriends,
    maxPendingRequests: active ? PREMIUM_PLAN.maxPendingRequests : GAME_CONFIG.social.maxPendingRequests,
    showcaseSlots: active ? PREMIUM_PLAN.showcaseSlots : GAME_CONFIG.social.showcaseSlots,
    maxTradeCardsPerSide: active ? PREMIUM_PLAN.maxTradeCardsPerSide : GAME_CONFIG.market.maxTradeCardsPerSide,
    maxTradeAnima: active ? PREMIUM_PLAN.maxTradeAnima : GAME_CONFIG.market.maxTradeAnima,
  };
}

export function boosterQuantities(active: boolean): number[] {
  return active
    ? Array.from({ length: PREMIUM_PLAN.maxBoosterBatch }, (_, index) => index + 1)
    : [...GAME_CONFIG.allowedQuantities];
}

export function isPremiumCosmetic(kind: string, key: string): boolean {
  return Object.entries(PREMIUM_COSMETICS).some(([candidateKind, candidateKey]) => candidateKind === kind && candidateKey === key);
}
